var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex items-start w-full space-x-10"},[_c('div',{staticClass:"w-1/5 px-8 py-4 rounded-panel bg-headerGray"},[_vm._v("\n        Pages\n    ")]),_vm._v(" "),_c('div',{staticClass:"w-4/5 px-8 py-4 rounded-panel bg-headerGray"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }